import { createSlice } from "@reduxjs/toolkit";
const globalReducer = createSlice({
  name: "global",
  initialState: {
    success: "",
    searchBar: false,
    openSidebar: true,
  },
  reducers: {
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    clearMessage: (state) => {
      state.success = "";
    },
    setOpenSidebar: (state, action) => {
      state.openSidebar = action.payload;
    },
  },
});
export const { setSuccess, clearMessage, setOpenSidebar } =
  globalReducer.actions;
export default globalReducer.reducer;
